<p-panel header="Testergebnis">
    Testergebnis
</p-panel>